import { Component, OnInit, AfterViewChecked } from '@angular/core';
import { LoginDataService } from './services/dhukan/login-data.service';
import { BnNgIdleService } from 'bn-ng-idle'; 

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit,AfterViewChecked  {
  
 
  title = 'RSUPPORT';

  islogin:boolean=false;

  constructor(private appService: LoginDataService, private bnIdle: BnNgIdleService) {
    this.bnIdle.startWatching(300).subscribe((res) => {
      if (res) {
        sessionStorage.removeItem("sptoken");
        
        this.appService.fnCheckLogin();
      }
    })

    this.appService.fnCheckLogin();
  }

  ngOnInit() { 
    
   
  }

  ngAfterViewChecked(): void {

    setTimeout(() =>  this.islogin=this.appService.islogin );
     
  }

}
